interface EnvironmentConfig {
  API_BASE_URL: string;
  REDIRECT_URL: string;
  SUCCESS_REDIRECT_URL: string;
  ENVIRONMENT: "development" | "production";
  DEBUG: boolean;
}

// Configuration par défaut
const defaultConfig: EnvironmentConfig = {
  API_BASE_URL: "https://dev.api.mpg.football",
  REDIRECT_URL: "https://shadow-ligueun.web.onvesper.com/",
  SUCCESS_REDIRECT_URL: "https://shadow-ligueun.web.onvesper.com/",
  ENVIRONMENT: "development",
  DEBUG: true,
};

// Fonction pour récupérer la configuration selon l'environnement
export const getEnvironmentConfig = (): EnvironmentConfig => {
  const env = process.env.NODE_ENV || "development";

  // Configuration de base
  const config: EnvironmentConfig = {
    API_BASE_URL:
      process.env.REACT_APP_API_BASE_URL || defaultConfig.API_BASE_URL,
    REDIRECT_URL:
      process.env.REACT_APP_REDIRECT_URL || defaultConfig.REDIRECT_URL,
    SUCCESS_REDIRECT_URL:
      process.env.REACT_APP_SUCCESS_REDIRECT_URL ||
      defaultConfig.SUCCESS_REDIRECT_URL,
    ENVIRONMENT:
      (process.env.REACT_APP_ENVIRONMENT as "development" | "production") ||
      env,
    DEBUG: process.env.REACT_APP_DEBUG === "true" || env === "development",
  };

  // Log de la configuration en mode debug
  if (config.DEBUG) {
    console.log("🔧 Configuration chargée:", {
      environment: config.ENVIRONMENT,
      apiBaseUrl: config.API_BASE_URL,
      redirectUrl: config.REDIRECT_URL,
      successRedirectUrl: config.SUCCESS_REDIRECT_URL,
      debug: config.DEBUG,
    });
  }

  return config;
};

// Configuration exportée
export const config = getEnvironmentConfig();

// URLs des API
export const API_ENDPOINTS = {
  GET_ONBOARDING_LINK: `${config.API_BASE_URL}/ligue1-plus/id-now/get-link`,
  CHECK_RESULT: `${config.API_BASE_URL}/ligue1-plus/id-now/check-result`,
} as const;

// Utilitaires
export const isDevelopment = config.ENVIRONMENT === "development";
export const isProduction = config.ENVIRONMENT === "production";
export const isDebug = config.DEBUG;
